import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyCheckBox = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.552734, width: 16, height: 16, rx: 2, fill: "#F7F6F5" }), /* @__PURE__ */ React.createElement("rect", { x: 1.05273, y: 0.5, width: 15, height: 15, rx: 1.5, stroke: "currentColor", strokeOpacity: 0.15 }));
const ForwardRef = forwardRef(SvgEmptyCheckBox);
export { ForwardRef as ReactComponent };
